<template>
    <b-button variant="primary" @click.stop="exportar()" v-if="mostrarBtn">
        <i class="fa fa-file-pdf-o ml-2"></i> Exportar
    </b-button>
</template>

<script>
import download from './../../../shared/download'
import { pagamentoStatus } from './PagamentoStatus'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => {}
        },

        pagamentosServicos: {
            type: Object,
            required: true
        }
    },

    data() {
        return {}
    },

    methods: {
        exportar() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .exportar(this.pagamento.pagamentoId)
                .then((response) => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Falha ao exportar o Protocolo de Pagamento',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            download(
                                response,
                                `ProtocoloDePagamentos_${this.pagamento.protocolo}.pdf`
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    created() {},

    computed: {
        mostrarBtn() {
            if (this.$route.name == 'GesconAprovadoresPagamentoDetalhar') {
                return (
                    this.$temAcessoView('GESCON-APR-PAG-01') && 
                    this.pagamento.status === pagamentoStatus.CONCLUIDO 
                )
            }
            return (
                this.$temAcessoView('GESCON-UFI-PAG-01') &&
                this.pagamento.status === pagamentoStatus.CONCLUIDO
            )
        }
    },

    watch: {},

    validations: {}
}
</script>
